// Copyright (c) 2024. UpCircle Technology AG.
// All rights reserved. Redistribution in source and/or binary forms,
// with or without modification, is not permitted.

import React from "react";
import "./DeliveriesTableCard.scss";
import { useTranslation } from "react-i18next";
import DeliveriesTable from "../../../components/Suppliers/DeliveriesTable";

export default function DeliveriesTableCard({cardData, payload}) {
    const { t } = useTranslation();
    
    // If there are no deliveries, display a message
    if (!payload.deliveries || Object.keys(payload.deliveries).length === 0) {
        return (
            <div className="deliveries-table-card-body">
                <p>{t("no_deliveries")}</p>
            </div>
        );
    }

    return (
        <div className="deliveries-table-card-body">
            <DeliveriesTable 
                deliveries={payload.deliveries}
                activeDelivery={payload.activeDelivery}
                onSelectDelivery={payload.setActiveDelivery}
                deliveriesSettings={payload.deliveriesSettings}
            />
        </div>
    );
}